import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { GlobalPriceChart } from "./global-price-chart.entity";
import { GlobalPriceChartRequest, GlobalPriceChartResponseModel } from "@gtpl/shared-models/masters";
import { GlobalPriceChartLog } from "./global-price-chart-log.entity";
import { CommonResponse } from "@gtpl/shared-models/production-management";

@Injectable()
export class GlobalPriceChartService {
    constructor(
        @InjectRepository(GlobalPriceChart)
        private globalPriceRepo: Repository<GlobalPriceChart>,
        @InjectRepository(GlobalPriceChartLog)
        private globalPriceLogRepo: Repository<GlobalPriceChartLog>,
        
    ) { }

    async getAllPriceCharts():Promise<GlobalPriceChartResponseModel>{
        try{
            const data = await this.globalPriceRepo.find({order:{createdAt:'ASC'}})
            if(data){
                const requestData = data.map(item=>new GlobalPriceChartRequest(item.id,item.component,item.price,item.type,item.createdAt,item.createdUser,item.updatedAt,item.updatedUser))
                return new GlobalPriceChartResponseModel(true,1, 'Data retrieved successfully', requestData)
            }else{
                return new GlobalPriceChartResponseModel(false,0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    
    async updatePriceCharts(req: GlobalPriceChartRequest): Promise<GlobalPriceChartResponseModel> {
        try {
            let success = false;
            let message = '';
            const existingRecord = await this.globalPriceRepo.findOne({ component: req.component });
            if (existingRecord && existingRecord.id !== req.id) {
                message = 'Component already exists.';
                return new GlobalPriceChartResponseModel(success, 0, message);
            }
    
            const mainData = await this.globalPriceRepo.findOne({ id: req.id });
            if (!mainData) {
                const priceChartEntity = new GlobalPriceChart();
                priceChartEntity.component = req.component;
                priceChartEntity.price = req.price;
                priceChartEntity.type = req.type
                await this.globalPriceRepo.save(priceChartEntity);
                message = 'Created Successfully';
                success = true;
            } else {
                const updateData = await this.globalPriceRepo.update({ id: req.id }, { component: req.component, price: req.price });
                if (updateData.affected) {
                    const globalPriceLog = new GlobalPriceChartLog();
                    globalPriceLog.gpcInfo = mainData;
                    globalPriceLog.effectiveFrom = mainData?.createdAt
                    globalPriceLog.oldPrice = mainData?.price;
                    await this.globalPriceLogRepo.save(globalPriceLog);
    
                    message = 'Updated Successfully';
                    success = true;
                }
            }
    
            return new GlobalPriceChartResponseModel(success, 1, message);
        } catch (err) {
            throw err;
        }
    }
    
    async getAntiDumpingPrice():Promise<CommonResponse>{
        try{
            const data = await this.globalPriceRepo.find({where:{component:'Antidumping duty'}})
            if(data){

                return new CommonResponse(true,1,'Data retrieved successfully', data)
            }else{
                return new CommonResponse(false,0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
}